<template>
  <div class="col-12">
    <BarChart :height="650" :chartData="testData" :options="options" />
  </div>
</template>

<script>
import { defineComponent, computed, ref } from "vue";
import { BarChart } from "vue-chart-3";
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);

export default defineComponent({
  components: { BarChart },
  props: ["labels", "datasets"],
  setup(props) {
    const testData = computed(() => ({
      labels: props.labels,
      datasets: props.datasets,
    }));

    const options = ref({
      responsive: true,
      plugins: {
        legend: {
          position: "top",
        },
        title: {
          display: true,
        },
      },
    });

    return { testData, options };
  },
});
</script>
